<template>
  <div v-if="furnishings.length">
    <h2>{{ t('furnishings.title') }}</h2>
    <ul :class="$style.list">
      <li v-for="furnishing in furnishings" :key="furnishing.name">
        <HgIcon :icon="furnishing.icon" size="large" />
        <p>{{ t(`furnishings.fields.${furnishing.name}`) }}</p>
      </li>
    </ul>
  </div>
</template>

<script lang="ts" setup>
import { HgIcon } from '@smg-real-estate/domus';
import { Characteristics, Listing } from '@smg-real-estate/hg-rets-schema';
import { computed } from 'vue';

import { useI18n } from 'vue-i18n';
import { furnishingFields } from './models';

const { t } = useI18n();

defineOptions({
  name: 'FeaturesFurnishings',
});

interface Props {
  listing: Listing;
}

const props = defineProps<Props>();

const furnishings = computed(() => {
  const characteristics: Characteristics = props.listing.characteristics ?? {};

  return furnishingFields.filter(({ name }) => !!characteristics[name]);
});
</script>

<style lang="scss" module>
@import '@/assets/variables';

.list {
  display: flex;
  flex-direction: column;
  gap: $space-75;
  max-width: 100%;
  padding: 0;
  margin: 0;
  overflow: hidden;
  list-style-type: none;

  > li {
    display: flex;
    flex-direction: row;
    gap: $space-75;
    align-items: center;
    line-height: 1.5;

    > p {
      margin: 0;
    }
  }
}
</style>
